// Organizations
export const organizations = [
    { id: 1, name: 'HSCL' },
    { id: 2, name: 'SANHDEF' },
    { id: 3, name: 'HSCL/SANHDEF'},
]

// Available projects with organization associations
export const availableProjects = [
    { id: 1, name: 'Pooled Procurement System for Malaria Commodities', org: 'HSCL', orgId: 1, code: 'PPMC-001' },
    { id: 2, name: 'Commercialization Plans for SRH Products', org: 'HSCL', orgId: 1, code: 'DCPS-002' },
    { id: 3, name: 'Regional Health Market Reassessment - SRH', org: 'HSCL', orgId: 1, code: 'RHMA-003' },
    { id: 4, name: 'Family Planning Quantification & Forecasting', org: 'HSCL', orgId: 1, code: 'RQFP-004' },
    { id: 5, name: 'National Nutrition Resource Mobilization', org: 'HSCL', orgId: 1, code: 'NNRM-005' },
    { id: 6, name: 'Kano Health Systems Strengthening', org: 'sanhdef', orgId: 2, code: 'KHSS-006' },
    { id: 7, name: 'Lagos AOP Design and PHC Support', org: 'HSCL', orgId: 1, code: 'LADS-007' },
    { id: 8, name: 'HIV Epidemic Control - Cluster 3', org: 'HSCL/sanhdef', orgId: 3, code: 'ACHE-008' },
]

// Departments
export const departments = [
    { id: 1, name: 'Human Resources' },
    { id: 2, name: 'Finance' },
    { id: 3, name: 'Technical Services' },
    { id: 4, name: 'Programs' },
    { id: 5, name: 'Monitoring & Evaluation' },
    { id: 6, name: 'Administration' },
    { id: 7, name: 'Supply Chain' },
    { id: 8, name: 'Communications' },
]

// Supervisors (sample list - can be from employees)
export const supervisors = [
    { id: 1, name: 'Emmanuel Obi', role: 'Project Manager' },
    { id: 2, name: 'Susie Willis', role: 'Technical Lead' },
    { id: 3, name: 'Tunde Balogun', role: 'Health Specialist' },
    { id: 4, name: 'Bello Mohammed', role: 'Program Officer' },
    { id: 5, name: 'Folake Ogunleye', role: 'Finance Officer' },
]

// Relationship options for Next of Kin
export const relationships = [
    { id: 1, name: 'Parent' },
    { id: 2, name: 'Spouse' },
    { id: 3, name: 'Sibling' },
    { id: 4, name: 'Child' },
    { id: 5, name: 'Guardian' },
    { id: 6, name: 'Other' },
]

// Role/Job titles
export const roles = [
    'Project Manager',
    'Technical Lead',
    'Program Officer',
    'Health Specialist',
    'M&E Specialist',
    'Finance Officer',
    'HR Officer',
    'Communications Officer',
    'Supply Chain Officer',
    'Administrative Assistant',
    'Data Analyst',
    'Research Analyst',
    'Field Coordinator',
    'Senior Advisor',
    'Director',
]

// Initial form data structure
export const initialFormData = {
    personalInfo: {
        firstName: '',
        middlename: '',
        lastName: '',
        avatar: null,
    },
    contactDetails: {
        email: '',
        phone: '',
        alternatePhone: '',
        address: {
            street: '',
            city: '',
            state: '',
            country: '',
            postalCode: '',
        }
    },
    nextOfKin: {
        name: '',
        relationship: '',
        phone: '',
        alternatePhone: '',
        email: '',
        address: '',
    },
    employmentDetails: {
        employeeId: '',
        joinDate: '',
        role: '',
    },
    assignments: {
        supervisorId: null,
        departmentId: null,
        organizationIds: [],
        projectAssignments: []
    }
}

// Helper function to get organization color
export const getOrgColor = (org) => {
    if (org === 'HSCL') return 'bg-blue-100 text-blue-700'
    if (org === 'sanhdef') return 'bg-emerald-100 text-emerald-700'
    return 'bg-purple-100 text-purple-700'
}

// Helper function to get project by ID
export const getProjectById = (id) => availableProjects.find(p => p.id === id)

// Helper function to get department by ID
export const getDepartmentById = (id) => departments.find(d => d.id === id)

// Helper function to get supervisor by ID
export const getSupervisorById = (id) => supervisors.find(s => s.id === id)

// Helper function to get organization by ID
export const getOrganizationById = (id) => organizations.find(o => o.id === id)
